<template>
  <section>
    <tourist-info-list :query="query" />
  </section>
</template>

<script>
import TouristInfoList from '@/components/catalogs/TouristInfoList'

export default {
  name: 'CatalogTouristInfos',
  components: {
    TouristInfoList
  },

  data() {
    const { query } = this.$route

    return {
      query: query
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === from.name) {
      this.query = to.query
    }

    next()
  }
}
</script>
